import React from 'react';
import { Icon } from '../core/Icon.jsx';

const TONE_COLOR = {
  green: 'var(--brand-green)',
  amber: 'var(--status-pending)',
  red: 'var(--status-overdue)',
  blue: 'var(--accent-blue)',
  default: 'var(--text-strong)',
};

/**
 * StatCard — KPI tile: muted label over a large colored value.
 * The app's "Total Mes $12,450.00" / "Pendiente $2,105.00" tiles.
 */
export function StatCard({ label, value, tone = 'default', icon, style = {}, ...rest }) {
  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--pad-card)',
        fontFamily: 'var(--font-sans)',
        minWidth: 160,
        boxShadow: 'var(--shadow-card)',
        ...style,
      }}
      {...rest}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        {icon && <Icon name={icon} size={16} color="var(--text-faint)" />}
        <span style={{ fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-faint)' }}>{label}</span>
      </div>
      <div style={{
        fontSize: 'var(--fs-money)',
        fontWeight: 'var(--fw-extrabold)',
        letterSpacing: 'var(--ls-tight)',
        color: TONE_COLOR[tone] || TONE_COLOR.default,
        lineHeight: 1,
      }}>
        {value}
      </div>
    </div>
  );
}
